import React, {Component} from 'react'
import ReactQuill from 'react-quill'
import MergeFieldsSelector from "./mergefields.component.jsx";
import {defineMessages, injectIntl} from "react-intl";
import ProposalMergeFields from "../../template/MergeFields.jsx";

const uuidv4 = require('uuid/v4')

const DefaultColors = [
    "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
    "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
    "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
    "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
    "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466",
]

const messages = defineMessages({
    merge_fields_btn: {
        id: 'common.rich_text.merge_fields_btn',
        defaultMessage: 'Merge fields',
    },
})

class RichTextEditor extends Component {

    constructor(props) {
        super(props)
        this.state = {
            enableMergeFields: this.props.enableMergeFields || false,
            simple: this.props.simple || false,
            allowedFields: this.props.allowedFields || [],
            text: this.props.value,
            height: this.props.height || 400,
            colors: this.props.colors || [],
            options: '',
            toolbarId: 'toolbar-' + uuidv4(),
            variables:this.props.variables || "",
            pricingTableMergeFieldsOnly: this.props.pricingTableMergeFieldsOnly || false,
        }
        const defaultCallback = () => {
        }
        this.onChange = this.props.onChange || defaultCallback
        this.reactQuillRef = null
        this.quillRef = null
        this.modules = {
            toolbar: {
                container: "#" + this.state.toolbarId,
                handlers: {
                    "merge-fields": (val) => {
                        const range = this.quillRef.getSelection()
                        let position = range ? range.index : 0
                        this.setState({
                            options: <MergeFieldsSelector
                                allowedFields={this.state.allowedFields}
                                variables={this.props.variables}
                                onChange={val => {
                                    //Replace the special characters with _ plus remove the first and the last curly braces.
                                    val = ProposalMergeFields.formatCustomFieldNameToVariable(val.substring(1, val.length - 1),false)
                                    this.quillRef.insertText(position, val)
                                }}
                                onClose={() => {
                                    this.setState({options: ''})
                                }}
                                pricingTableMergeFieldsOnly={this.state.pricingTableMergeFieldsOnly}
                            />
                        })

                    },
                }
            },
            clipboard: {
                matchVisual: false
            },
        }

        this.formats = [
            'size', 'color', 'background',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'align'
        ]

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(value) {
        this.setState({text: value}, () => {
            this.onChange(value)
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({text: nextProps.value})
    }

    componentDidMount() {
        this.attachQuillRefs()
    }

    componentDidUpdate() {
        this.attachQuillRefs()
    }

    attachQuillRefs() {
        if (typeof this.reactQuillRef.getEditor !== 'function') return;
        this.quillRef = this.reactQuillRef.getEditor();
    }

    render() {
        return (
            <div>
                <div id={this.state.toolbarId}>
                    {!this.state.simple ? <span className="ql-formats">
                        <select className="ql-size">
                            <option value="small"></option>
                            <option selected></option>
                            <option value="large"></option>
                            <option value="huge"></option>
                        </select>
                    </span> : ''}
                    <span className="ql-formats">
                        <button className="ql-bold"></button>
                        <button className="ql-italic"></button>
                        <button className="ql-underline"></button>
                        <button className="ql-strike"></button>
                        <button className="ql-bullet"></button>
                        <button className="ql-blockquote"></button>
                    </span>
                    <span className="ql-formats">
                        <button className="ql-list" value="ordered"></button>
                        <button className="ql-list" value="bullet"></button>
                        <button className="ql-indent" value="-1"></button>
                        <button className="ql-indent" value="+1"></button>
                    </span>

                    <span className="ql-formats">
                        <button className="ql-link"></button>
                        <select className="ql-align">
                            <option selected="selected"></option>
                            <option value="center"></option>
                            <option value="right"></option>
                            <option value="justify"></option>
                        </select>
                    </span>
                    {!this.state.simple ? <span className="ql-formats">
                        <select className="ql-color">
                            {DefaultColors.concat(this.state.colors).map(c => <option key={c} value={c}/>)}
                        </select>
                        <select className="ql-background">
                            {DefaultColors.concat(this.state.colors).map(c => <option key={c} value={c}/>)}
                        </select>
                    </span> : ''}
                    <span className="ql-formats">
                        <button className="ql-clean"></button>
                    </span>
                    {this.state.enableMergeFields ? <span className="ql-formats">
                        <button className="ql-merge-fields text-left w-auto" style={{fontSize: '12px'}}>
                            {this.props.intl.formatMessage(messages.merge_fields_btn)}
                        </button>
                    </span> : ''}
                </div>
                {this.state.options}
                <ReactQuill
                    modules={this.modules}
                    formats={this.formats}
                    value={this.state.text || ''}
                    ref={(el) => {
                        this.reactQuillRef = el
                    }}
                    onChange={this.handleChange}
                    style={{
                        height: this.state.height + 'px'
                    }}
                />
            </div>

        )
    }
}

export default injectIntl(RichTextEditor)





// WEBPACK FOOTER //
// ./src/common/rich-text/editor.component.jsx